<template>
  <svg viewBox="0 0 22 12" fill="none">
    <path
      d="M1 1L11 11L21 1"
      stroke="var(--geist-foreground)"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    ></path>
  </svg>
</template>

<script>
export default {
  name: 'zi-down-icon',
}
</script>
